<script setup lang="ts">
import {useRoute} from "vue-router";
import {SystemService} from "@/api/api.ts";
import {ElNotification} from "element-plus";
import {ref} from "vue";

const route = useRoute()
const name = route.params.name as string
const info = ref<string>()
const loading = ref(false)

const getPrivacy = async () => {
  try {
    loading.value = true
    const res = await SystemService.getSystemInfo({
      title: name
    })
    if (res.data.code === 200) {
      info.value = res.data.data.content
    } else {
      ElNotification.error({
        message: res.data.msg
      })
    }
  } catch (err) {
    console.warn(err)
  } finally {
    loading.value = false
  }
}

getPrivacy()
</script>

<template>
  <div class="bg-#f5f5f5">
    <div class="pt-16px mx-4rem" ref="infoDom">
      <div class="flex justify-center text-48px font-bold text-#bfbfbf text-center">
        {{ `“${name}”` }}
      </div>
      <div class="h-1px border-solid border-1px border-#707070 mt-40px"></div>
      <div class="mt-48px min-h-100vh" v-loading="loading">
        <div v-html="info"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
